import Style from './answerPreviewRow.module.scss';
import { FormTitleProps } from 'src/features/generalForms/builder/types/BaseControlTypes';
import { useOverflowDetection } from './useOverflowDetection';
import { Tooltip } from 'uikit/tooltip/tooltip.component';
import { isNil } from 'lodash';
import { useScopedTranslation } from 'src/application/localisation/useScopedTranslation';

export type AnswerPreviewRowType<T> = FormTitleProps & {
  isOptional?: boolean;
  value: T | undefined | null;
  renderValue: (value: T) => React.JSX.Element | string;
};

export const AnswerPreviewRow = <T,>(props: AnswerPreviewRowType<T>) => {
  const { t } = useScopedTranslation('GeneralFormBuilder.UiKit.Validation');
  const { ref: prefixRef, isOverflowed } = useOverflowDetection<HTMLDivElement>();

  return (
    <div className={Style.container}>
      <div className={Style.titleWithPrefix}>
        {props.prefix && (
          <Tooltip text={props.prefix} disabled={!isOverflowed}>
            <div className={Style.prefix} ref={prefixRef}>
              {props.prefix}
            </div>
          </Tooltip>
        )}
        {props.title && (
          <div className={Style.title}>
            <span>{props.title}</span>
            {props.isOptional && <span className={Style.optionalMark}>{t('Optional')}</span>}
          </div>
        )}
      </div>
      {!isNil(props.value) && <div className={Style.value}>{props.renderValue(props.value)}</div>}
    </div>
  );
};
